const errorLog = {
    '190001': '超时未操作，系统已自动登出，请重新登录',
    '190002': '未查询到该用户，请确认账号信息是否正确',
    '190003': '当前用户已存在，请勿重复创建',
    '190004': '查询用户信息失败，请重试',
    '190005': '账户或密码错误',
    '190006': '当前角色名称已存在，请勿重复创建！',
    '190007': '未查询到当前角色，请确认角色名称是否正确',
    '190008': '角色名称需在30字以内',
    '190009': '该角色有用户使用，不能删除',
    '190010': '不能对超级管理员角色操作',
    '190011': '只支持png/jpg格式的图片上传',
    '190012': '文件大小不能超过2M',
    '190013': '文件上传失败',
    '190014': '新增角色失败',
    '190015': '该代理商下有商户，不能删除',
    '190016': '该代理商下有二级代理商，不能删除',
    '190017': '查询代理商信息失败',
    '190018': '该手机号已注册，请更换新手机号进行注册',
    '190019': '您的账号已停用（或未注册），请联系相关部门负责人或超级管理员处理！',
    '190020': '查询费率失败',
    '190021': '用户对应的角色不存在',
    '190022': '用户角色对应的菜单权限不存在',
    '190023': '您暂未开启任何功能权限，请联系部门负责人！',
    '190024': '原始密码错误，请重新输入',
    '190025': '创建者不存在',
    '199000': '任务组名称重复',
    '190035': '暂无数据',
    '5000': '系统繁忙，请稍后再试',
    '6000': '数据返回错误，请稍后再试',
    '199001': '用户不在线'
  }
  export default errorLog
  


// WEBPACK FOOTER //
// ./src/utils/errorLog.js